<template>
  <div class="home">
<Navigation/>
    <div class="section bg-primary-3">
    <div class="container text-center">
      <h1>Humor</h1>
      <div class="text-large">Laughter is the best medicine.</div>
    </div>
  </div>
<Posts Category="humor" ShowTitle="false"/>


  </div>

</template>

<script>
import Navigation from "@/components/Navigation.vue"
import Posts from "@/components/PostCollection.vue"

export default {
  name: "home",
  components: {
    Navigation,
    Posts
  }
};
</script>
